function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9638_13770)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 6.51937V6.82579L15 6.82581C11.6342 7.20447 9 10.0346 9 13.5V16.8105L8.03027 17.7803C7.88965 17.9209 7.69922 18 7.5 18H3.75C3.33545 18 3 17.6645 3 17.25V13.5C3 13.3008 3.0791 13.1103 3.21973 12.9697L9.11206 7.07739C9.03662 6.698 9 6.34277 9 6C9 2.69165 11.6916 0 15 0C18.3083 0 21 2.69165 21 6C21 6.91258 20.7714 7.79818 20.3725 8.60678C19.3362 7.62743 17.9889 6.99443 16.5 6.82414V6.51937C16.94 6.25753 17.25 5.79784 17.25 5.24999C17.25 4.42308 16.5769 3.74999 15.75 3.74999C14.9231 3.74999 14.25 4.42308 14.25 5.24999C14.25 5.79784 14.56 6.25752 15 6.51937ZM16.5 11.2507V8.32654C19.0375 8.6944 21 10.863 21 13.5007V23.0008C21 23.553 20.5523 24.0008 20 24.0008H11.5C10.9477 24.0008 10.5 23.553 10.5 23.0008V13.5007C10.5 10.863 12.4625 8.6944 15 8.32654V11.2507C15 11.6653 15.3354 12.0007 15.75 12.0007C16.1646 12.0007 16.5 11.6653 16.5 11.2507Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9638_13770"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgKeyless = function SvgKeyless(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeyless, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keyless.3a444643.svg";
export { ForwardRef as ReactComponent };